export default {
  'Extract audio': 'オーディオを抽出する',
  'Mute': 'ミュート',
  'Split video and audio': '動画と音声を分割する',
}